export default "__VITE_ASSET__$72TITlW__"